export default __webpack_public_path__ + "static/media/remove-fav-red.77b23d92.svg";